import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'


export const cseCard = {
  // Layout
  height: css`var(--cse-card-height, auto)`,
  gap: css`var(--cse-card-gap, ${csSpacing.spacing04})`,
  paddingBlock: css`var(--cse-card-padding-y, 0)`,
  paddingInline: css`var(--cse-card-padding-x, 0)`,

  // Border
  borderRadius: css`var(--cse-card-border-radius, ${csBorder.radiusMinimal})`,
  borderWidth: css`var(--cse-card-border-width, ${csBorder.width})`,
  borderColor: css`var(--cse-card-border-color, ${csColorBorder.light})`,
  borderColorHover: css`var(--cse-card-border-color-hover, ${csColorBorder.light})`,

  // Background
  backgroundColor: css`var(--cse-card-background-color, ${csColorBackground.primary})`,
  backgroundColorHover: css`var(--cse-card-background-color-hover, ${csColorBackground.primary})`,

  // Shadow
  boxShadowHover: css`var(--cse-card-box-shadow-hover, ${csShadow.default})`,

  // Image
  imageBorderRadius: css`var(--cse-card-image-border-radius, ${csBorder.radiusMinimal})`,

  // Header
  headerDisplay: css`var(--cse-card-header-display, block)`,
  headerPaddingBlock: css`var(--cse-card-header-padding-y, 0)`,
  headerPaddingInline: css`var(--cse-card-header-padding-x, 0)`,

  // Body
  bodyPaddingBlock: css`var(--cse-card-body-padding-y, ${csSpacing.spacing05})`,
  bodyPaddingInline: css`var(--cse-card-body-padding-x, ${csSpacing.spacing05})`,
  bodyFlexGrow: css`var(--cse-card-body-flex-grow, 0)`,

  // Footer
  footerDisplay: css`var(--cse-card-footer-display, block)`,
  footerPaddingBlock: css`var(--cse-card-footer-padding-y, ${csSpacing.spacing05})`,
  footerPaddingInline: css`var(--cse-card-footer-padding-x, ${csSpacing.spacing05})`,

  // Inline variant
  inlineWrapperFlexDirection: css`var(--cse-card-inline-wrapper-flex-direction, column)`,
  inlineWrapperGap: css`var(--cse-card-inline-wrapper-gap, 0)`
}

export const style: CSSResult = css`
  :host {
    display: inline-block;
  }

  .cse-card {
    height: ${cseCard.height};
    display: flex;
    flex-direction: column;
    gap: ${cseCard.gap};
    border-color: ${cseCard.borderColor};
    border-radius: ${cseCard.borderRadius};
    border-style: solid;
    border-width: ${cseCard.borderWidth};
    background-color: ${cseCard.backgroundColor};
    padding-block: ${cseCard.paddingBlock};
    padding-inline: ${cseCard.paddingInline};
  }

  .cse-card:hover {
    background-color: ${cseCard.backgroundColorHover};
    border-color: ${cseCard.borderColorHover};
    box-shadow: ${cseCard.boxShadowHover};
  }

  /* Wide variant - flex row layout */
  .cse-card.variant-wide {
    flex-direction: row;
  }

  /* Inline variant - header on left, content on right */
  .cse-card.variant-inline {
    flex-direction: row;
  }

  .cse-card.variant-inline .content-wrapper {
    display: flex;
    flex-direction: ${cseCard.inlineWrapperFlexDirection};
    gap: ${cseCard.inlineWrapperGap};
    flex: 1;
  }

  .header[hidden],
  .body[hidden],
  .footer[hidden] {
    display: none;
  }

  .header {
    display: ${cseCard.headerDisplay};
    padding-block: ${cseCard.headerPaddingBlock};
    padding-inline: ${cseCard.headerPaddingInline};
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-block: ${cseCard.bodyPaddingBlock};
    padding-inline: ${cseCard.bodyPaddingInline};
    flex-grow: ${cseCard.bodyFlexGrow};
  }

  /* In wide variant, body takes up available space */
  .cse-card.variant-wide .body {
    flex: 1;
  }

  .footer {
    display: ${cseCard.footerDisplay};
    padding-block: ${cseCard.footerPaddingBlock};
    padding-inline: ${cseCard.footerPaddingInline};
  }

  ::slotted(cse-image),
  ::slotted([slot="header"]) cse-image,
  ::slotted([slot="body"]) cse-image,
  ::slotted([slot="footer"]) cse-image {
    --cse-image-border-radius: ${cseCard.imageBorderRadius};
  }
`
